var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var _a = require('./tokens'), trigTokenMap = _a.trigTokenMap, trigTokenTypes = _a.trigTokenTypes;
import { Parser, } from 'chevrotain';
import { TurtleParser } from '../turtle/TurtleParser';
var TrigParser = /** @class */ (function (_super) {
    __extends(TrigParser, _super);
    function TrigParser(config, tokens, lexerDefinition, performSelfAnalysis) {
        if (tokens === void 0) { tokens = trigTokenTypes; }
        if (lexerDefinition === void 0) { lexerDefinition = trigTokenTypes; }
        if (performSelfAnalysis === void 0) { performSelfAnalysis = true; }
        var _this = _super.call(this, config, tokens, lexerDefinition, false) || this;
        // NOTE: This parser can parse in two modes, 'standard' and 'stardog'. The
        // latter includes non-standard features like embedded triples patterns (edge
        // properties). Things are done this way to avoid deep inheritance trees
        // (e.g., one alternative is to create a StardogTurtleParser that extends
        // TurtleParser, then a StardogTrigParser that extends the
        // StardogTurtleParser, but that gets ugly...).
        _this.parse = function (document, mode) {
            if (mode === void 0) { mode = 'standard'; }
            _this.input = _this.lexer.tokenize(document).tokens;
            var cst = _this.trigDoc(0, [mode]);
            // Next two items are copied so that they can be returned/held after parse
            // state is cleared.
            var errors = _this.errors.slice();
            var semanticErrors = _this.semanticErrors.slice();
            _this.resetManagedState();
            return {
                errors: errors,
                semanticErrors: semanticErrors,
                cst: cst,
            };
        };
        _this.trigDoc = _this.RULE('trigDoc', function (mode) {
            var allowEdgeProperties = mode === 'stardog';
            _this.MANY(function () {
                _this.OR([
                    { ALT: function () { return _this.SUBRULE(_this.directive); } },
                    {
                        ALT: function () { return _this.SUBRULE(_this.block, { ARGS: [allowEdgeProperties] }); },
                    },
                ]);
            });
        });
        _this.block = _this.RULE('block', function (allowEdgeProperties) {
            _this.OR([
                {
                    ALT: function () {
                        return _this.SUBRULE(_this.triplesOrGraph, { ARGS: [allowEdgeProperties] });
                    },
                },
                {
                    ALT: function () {
                        return _this.SUBRULE(_this.wrappedGraph, { ARGS: [allowEdgeProperties] });
                    },
                },
                { ALT: function () { return _this.SUBRULE(_this.triples2); } },
                {
                    ALT: function () {
                        _this.CONSUME(trigTokenMap.GRAPH);
                        _this.SUBRULE(_this.labelOrSubject);
                        _this.SUBRULE1(_this.wrappedGraph, { ARGS: [allowEdgeProperties] });
                    },
                },
            ]);
        });
        _this.triplesOrGraph = _this.RULE('triplesOrGraph', function (allowEdgeProperties) {
            var didParseEmbeddedTriplePattern = false;
            _this.OR([
                {
                    ALT: function () { return _this.SUBRULE(_this.labelOrSubject); },
                },
                {
                    GATE: function () { return Boolean(allowEdgeProperties); },
                    ALT: function () {
                        var result = _this.SUBRULE(_this.EmbeddedTriplePattern);
                        didParseEmbeddedTriplePattern =
                            result.name === 'EmbeddedTriplePattern';
                    },
                },
            ]);
            _this.OR1([
                {
                    // embedded triple patterns cannot precede wrapped graphs
                    GATE: function () { return !didParseEmbeddedTriplePattern; },
                    ALT: function () {
                        return _this.SUBRULE(_this.wrappedGraph, { ARGS: [allowEdgeProperties] });
                    },
                },
                {
                    ALT: function () {
                        _this.SUBRULE(_this.predicateObjectList);
                        _this.CONSUME(trigTokenMap.Period);
                    },
                },
            ]);
        });
        _this.triples2 = _this.RULE('triples2', function () {
            _this.OR([
                {
                    ALT: function () {
                        _this.SUBRULE(_this.blankNodePropertyList);
                        _this.OPTION(function () { return _this.SUBRULE(_this.predicateObjectList); });
                        _this.CONSUME(trigTokenMap.Period);
                    },
                },
                {
                    ALT: function () {
                        _this.SUBRULE(_this.collection);
                        _this.SUBRULE1(_this.predicateObjectList);
                        _this.CONSUME1(trigTokenMap.Period);
                    },
                },
            ]);
        });
        _this.wrappedGraph = _this.RULE('wrappedGraph', function (allowEdgeProperties) {
            _this.CONSUME(trigTokenMap.LCurly);
            _this.OPTION(function () {
                return _this.SUBRULE(_this.triplesBlock, { ARGS: [allowEdgeProperties] });
            });
            _this.CONSUME(trigTokenMap.RCurly);
        });
        _this.triplesBlock = _this.RULE('triplesBlock', function (allowEdgeProperties) {
            _this.SUBRULE(_this.triples, { ARGS: [allowEdgeProperties] });
            _this.OPTION(function () {
                _this.CONSUME(trigTokenMap.Period);
                _this.OPTION1(function () {
                    return _this.SUBRULE(_this.triplesBlock, { ARGS: [allowEdgeProperties] });
                });
            });
        });
        _this.labelOrSubject = _this.RULE('labelOrSubject', function () {
            _this.OR([
                { ALT: function () { return _this.SUBRULE(_this.iri); } },
                { ALT: function () { return _this.SUBRULE(_this.BlankNode); } },
            ]);
        });
        if (performSelfAnalysis) {
            Parser.performSelfAnalysis(_this);
        }
        return _this;
    }
    return TrigParser;
}(TurtleParser));
export { TrigParser };
